module.exports = __webpack_public_path__ + "static/media/hotbid-four.4581ff4a.png";